<template>
  <div>
    <div class="wrapper">
      <SideBar2 />

      <div class="main-panel">
        <TopBar />
        <div class="row" style="margin:0">
          <div class="col-lg-9 col-12">
            <Slide />
            <div class="content">
              <div class="container-fluid">
                <div class="row mx-0 div-title-block" style="margin: 10px 30px 30px 30px">
                  <h4 style="font-weight: bold">Menu Category</h4>
                  <div class="hr-title"></div>
                </div>
                <div class="list-cate col-lg-12 col-xs-12">
                  <div class="col-lg-2 cate-item col-xs-6">
                    <div class="block-cate-item">
                      <img class="cate-img" src="/static/images-removebg-preview%20(1).png" alt="">
                      <p class="cate-name">Pizza</p>
                      <p class="cate-more"><i class="fas fa-angle-right"></i></p>
                    </div>
                  </div>
                  <div class="col-lg-2 cate-item col-xs-6">
                    <div class="block-cate-item">
                      <img class="cate-img" src="/static/images-removebg-preview%20(1).png" alt="">
                      <p class="cate-name">Pizza</p>
                      <p class="cate-more"><i class="fas fa-angle-right"></i></p>
                    </div>
                  </div>
                  <div class="col-lg-2 cate-item col-xs-6">
                    <div class="block-cate-item">
                      <img class="cate-img" src="/static/images-removebg-preview%20(1).png" alt="">
                      <p class="cate-name">Pizza</p>
                      <p class="cate-more"><i class="fas fa-angle-right"></i></p>
                    </div>
                  </div>
                  <div class="col-lg-2 cate-item col-xs-6">
                    <div class="block-cate-item">
                      <img class="cate-img" src="/static/images-removebg-preview%20(1).png" alt="">
                      <p class="cate-name">Pizza</p>
                      <p class="cate-more"><i class="fas fa-angle-right"></i></p>
                    </div>
                  </div>
                  <div class="col-lg-2 cate-item col-xs-6">
                    <div class="block-cate-item">
                      <img class="cate-img" src="/static/images-removebg-preview%20(1).png" alt="">
                      <p class="cate-name">Pizza</p>
                      <p class="cate-more"><i class="fas fa-angle-right"></i></p>
                    </div>
                  </div>
                  <div class="col-lg-2 cate-item col-xs-6">
                    <div class="block-cate-item">
                      <img class="cate-img" src="/static/images-removebg-preview%20(1).png" alt="">
                      <p class="cate-name">Pizza</p>
                      <p class="cate-more"><i class="fas fa-angle-right"></i></p>
                    </div>
                  </div>
                </div>
                <div class="list-shop list-product row col-lg-12">
                  <div class="card  shop-item-in-list col-md-3 col-sm-6 product-item" style="">
                    <img class="card-img-top img-shop-list" src="/static/prd.png" alt="Card image cap">
                    <div class="card-body card-body-product">
                      <div class="rating-shop" style="display: flex">
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                      </div>
                      <h5 class="card-title">Italia Pizze</h5>
                      <p class="card-text">$ <b>7</b>
                      <button class="btn-add-cart">+</button>
                      </p>
                    </div>
                  </div>
                  <div class="card  shop-item-in-list col-md-3 col-sm-6 product-item" style="">
                    <img class="card-img-top img-shop-list" src="/static/prd.png" alt="Card image cap">
                    <div class="card-body card-body-product">
                      <div class="rating-shop" style="display: flex">
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                      </div>
                      <h5 class="card-title">Italia Pizze</h5>
                      <p class="card-text">$ <b>7</b>
                        <button class="btn-add-cart">+</button>
                      </p>
                    </div>
                  </div>
                  <div class="card  shop-item-in-list col-md-3 col-sm-6 product-item" style="">
                    <img class="card-img-top img-shop-list" src="/static/prd.png" alt="Card image cap">
                    <div class="card-body card-body-product">
                      <div class="rating-shop" style="display: flex">
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                      </div>
                      <h5 class="card-title">Italia Pizze</h5>
                      <p class="card-text">$ <b>7</b>
                        <button class="btn-add-cart">+</button>
                      </p>
                    </div>
                  </div>
                  <div class="card  shop-item-in-list col-md-3 col-sm-6 product-item" style="">
                    <img class="card-img-top img-shop-list" src="/static/prd.png" alt="Card image cap">
                    <div class="card-body card-body-product">
                      <div class="rating-shop" style="display: flex">
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                      </div>
                      <h5 class="card-title">Italia Pizze</h5>
                      <p class="card-text">$ <b>7</b>
                        <button class="btn-add-cart">+</button>
                      </p>
                    </div>
                  </div>
                  <div class="card  shop-item-in-list col-md-3 col-sm-6 product-item" style="">
                    <img class="card-img-top img-shop-list" src="/static/prd.png" alt="Card image cap">
                    <div class="card-body card-body-product">
                      <div class="rating-shop" style="display: flex">
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                      </div>
                      <h5 class="card-title">Italia Pizze</h5>
                      <p class="card-text">$ <b>7</b>
                        <button class="btn-add-cart">+</button>
                      </p>
                    </div>
                  </div>
                  <div class="card  shop-item-in-list col-md-3 col-sm-6 product-item" style="">
                    <img class="card-img-top img-shop-list" src="/static/prd.png" alt="Card image cap">
                    <div class="card-body card-body-product">
                      <div class="rating-shop" style="display: flex">
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                      </div>
                      <h5 class="card-title">Italia Pizze</h5>
                      <p class="card-text">$ <b>7</b>
                        <button class="btn-add-cart">+</button>
                      </p>
                    </div>
                  </div>
                  <div class="card  shop-item-in-list col-md-3 col-sm-6 product-item" style="">
                    <img class="card-img-top img-shop-list" src="/static/prd.png" alt="Card image cap">
                    <div class="card-body card-body-product">
                      <div class="rating-shop" style="display: flex">
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                        <div class="five-pointed-star"></div>
                      </div>
                      <h5 class="card-title">Italia Pizze</h5>
                      <p class="card-text">$ <b>7</b>
                        <button class="btn-add-cart">+</button>
                      </p>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <Cart />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopBar from "./TopBar";
import SideBar2 from "./SideBar2";
import Slide from "../components/Slide";
import Cart from "../components/Cart";
export default {
  name: "Shop3",
  components: {Cart, Slide, SideBar2, TopBar}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Shop3.vue